var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Tên doanh nghiệp ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập tên doanh nghiệp, công ty..."},model:{value:(_vm.entry.name),callback:function ($$v) {_vm.$set(_vm.entry, "name", $$v)},expression:"entry.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }